// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Block_wrapper__3gV95","header":"Block_header__2uold","checkbox":"Block_checkbox__3w8eF","row":"Block_row__pXqv8","key":"Block_key__3HEdd","value":"Block_value__1ARvj"};